export const CN_ICON_VIEW = "egw-font-icon";
